import React from "react";
import { Helmet } from "react-helmet";
import { ROUTES } from "../../lib/constants";
import styles from "./AboutFiber.module.scss";
import { Image } from "../../components/Image/Image";
import superFooterSemicircle from "../../images/community-footer-semicircle-orange.svg";
import imgAboutFiberChart from "../../images/about-fiber-graph.png";
import { Button } from "../../components/Button/Button";

export const AboutFiber = (): React.JSX.Element => {
  return (
    <>
      <Helmet>
        <title>{ROUTES.aboutFiber.title}</title>
        <meta
          name="description"
          content="Cityside offers high speed 100% fiber-optic internet with symmetrical upload/download speeds up to 5 Gigs with unlimited data."
        />

        <meta property="og:title" content={`${ROUTES.aboutFiber.title}`} />
        <meta property="og:description" content="Cityside offers high speed 100% fiber-optic internet with symmetrical upload/download speeds up to 5 Gigs with unlimited data." />
        <meta property="og:url" content="https://www.citysidefiber.com/about-fiber" />
      </Helmet>

      <section className={styles.hero}>
        <div className={styles.designElement}></div>

        <div className="grid-12">
          <div className={styles.container}>
            <h1 className="headline__h1-xl">Why You Need Cityside Fiber</h1>
          </div>
        </div>
      </section>

      <section className={styles.mainContent}>
        <div className="grid-12">
          <div className="info">
            <h2>
              Today’s technology and online services demand a fiber-optic
              connection.
            </h2>
            <div className="text">
              <p>
                True Gig internet service powered by fiber technology is a clear
                upgrade from the outdated copper cable infrastructure from 40
                years ago. Fiber-optics are able to carry data faster with more
                reliability, more capacity, and at{" "}
                <span className="color--daylight-blue bold">symmetrical</span>{" "}
                speeds. That upload and download speed symmetry allows customers
                to have higher quality video calls, streaming TVs, gaming, and
                media, all running at the same time.{" "}
              </p>
              <p>
                If you're the type of person to see the word "fiber" and think
                about how your doctor is always on your case about eating more
                of it, it's okay, you're not alone.
              </p>
              <p>
                Fiber internet sounds fancy and great, but do we really need it?
                And what does it actually do for us?
              </p>
              <p>
                Well, the science behind it is very cool. Cityside Fiber allows
                whatever you are doing online to travel at lightspeed whether
                you are steaming movies, on a video call, a professional gamer,
                and more! Also, the new system is made for multiple users and
                devices at the same time in the same household!
              </p>
            </div>
          </div>
          <div className="img">
            <Image
              sources={[{ src: imgAboutFiberChart, breakpoint: "default" }]}
              alt="upload/download chart"
              loading="eager"
            />
          </div>
        </div>
      </section>
      <section className={styles.infoBar}>
        <div className="grid-12">
          <h2>
            Fiber-optic Internet <span>dominates old copper cable</span>
          </h2>
          <ul className={`checkmark-list ${styles.text}`}>
            <li>
              #1 in reliability for everything you do online and connect to at
              home
            </li>
            <li>
              Lightning-fast simultaneous uploading and downloading is awesome
            </li>
            <li>
              Our Fiber-optic internet simplifies your life with a premium
              connection
            </li>
          </ul>
        </div>
      </section>
      <section className={styles.History}>
        <h2>A quick history of telecommunication</h2>
        <div className={`${styles.Cards}`}>
          <div className="card card_1">
            <h3>Telephone</h3>
            <div>Built for voice calling on landlines</div>
          </div>
          <div className="card card_2">
            <h3>Cable</h3>
            <div>Built for TV signals on copper wiring</div>
          </div>
          <div className="card card_3">
            <h3>Fiber!</h3>
            <div>Built for the internet, built just for you!</div>
            <Button
              className="color--white button"
              path={ROUTES.checkAvailability.path}
              size="lg"
              gradient="orange"
            >
              Build your Package Today!
            </Button>
          </div>
        </div>
        <img className={styles.semicircle} src={superFooterSemicircle} alt="" />
      </section>
    </>
  );
};
